module.exports = __webpack_public_path__ + "static/media/icon-menu.764cdbe6.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/miami/ui/icon-menu.svg
// module id = 565
// module chunks = 0